interface MesclarObjetos<L> {
  primeiraLista: L[]
  segundaLista: L[]
  nomeDaPropriedade?: string
}
export function usarManipuladorObjetos() {
  const colher = <P = unknown, R = any[]>(
    array: P[],
    chaves: string[],
    mapeadoPara?: string[]
  ): R[] => {
    return array.map((item) => {
      if (mapeadoPara && mapeadoPara.length > 0) {
        return mapeadoPara.reduce((acumulador, valorAtual, indexAtual) => {
          acumulador[valorAtual] = item[chaves[indexAtual]]
          return acumulador
        }, {}) as R
      }
      return chaves.reduce((ac, at, indexAtual) => {
        ac[at] = item[at]
        return ac
      }, {}) as R
    })
  }
  const agruparPor = <A = any[]>(lista: A[], propriedade: string) => {
    return lista.reduce((grupo, filtro) => {
      grupo[filtro[propriedade]] = grupo[filtro[propriedade]] ?? []
      grupo[filtro[propriedade]].push(filtro)
      return grupo
    }, {})
  }
  const agruparValoresDe = <L, R = any>(
    lista: L[],
    nomeDaPropriedade: string
  ): R[] => {
    return lista.map((item) => item[nomeDaPropriedade])
  }
  const listaSemRepeticoes = <L>(
    lista: L[],
    nomeDaPropriedade: string
  ): L[] => {
    return Array.from(
      new Map(lista.map((item) => [item[nomeDaPropriedade], item])).values()
    )
  }

  const ordenarLista = <L = any>(
    lista: L[],
    nomeDaPropriedade: string,
    ordem: "ascendente" | "descendente" = "ascendente"
  ): L[] => {
    return lista.sort((a, b) => {
      if (a[nomeDaPropriedade] > b[nomeDaPropriedade]) {
        return ordem === "ascendente" ? 1 : -1
      }
      if (a[nomeDaPropriedade] < b[nomeDaPropriedade]) {
        return ordem === "ascendente" ? -1 : 1
      }
      return 0
    })
  }

  const mesclarObjetos = <L = any>({
    primeiraLista,
    segundaLista,
    nomeDaPropriedade = "id",
  }: MesclarObjetos<L>): L[] => {
    const primeira = new Map(
      primeiraLista.map((item) => [item[nomeDaPropriedade], item])
    )
    const segunda = new Map(
      segundaLista.map((item) => [item[nomeDaPropriedade], item])
    )

    return Array.from(new Map([...primeira, ...segunda]).values())
  }
  const verificarSeElementoTemConteudo = (valor: any): boolean => {
    if (valor === null || valor === undefined) {
      return false
    }
    if (typeof valor === 'string' && valor.trim() === '') {
      return false
    }
    if (Array.isArray(valor) && valor.length === 0) {
      return false
    }
    return true
  }
  return {
    agruparPor,
    agruparValoresDe,
    colher,
    listaSemRepeticoes,
    mesclarObjetos,
    ordenarLista,
    verificarSeElementoTemConteudo
  }
}
